/**
 * @fileoverview POST handler for the "/engagement/content_blocks/update_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementContentBlocksUpdateTagsCacheKeys } from "./constants";
import type { PostEngagementContentBlocksUpdateTagsProps, EngagementContentBlocksUpdateTagsResult } from "./types";

export const postEngagementContentBlocksUpdateTags = reactQueryMutationAdapter(
  engagementContentBlocksUpdateTagsCacheKeys,
  (props: PostEngagementContentBlocksUpdateTagsProps): Promise<EngagementContentBlocksUpdateTagsResult> => {
    return fetch("/engagement/content_blocks/update_tags", "POST", props);
  }
);
